import React from 'react';
import withDashboardSidebar from '../../components/with-dashboard-sidebar';

import * as S from './styles';
import useUploadsFailed from './uploads-transcribe-error';
import UploadsTable from './uploads-table';

const Uploads = () => {
  const {
    data: {
      uploadsFailed = [],
    },
    loading,
  } = useUploadsFailed({});

  return (
    <S.Container>
      <S.Header>
        <S.Title>
          This Page shows failed uploads
        </S.Title>
      </S.Header>

      {loading && (
        <S.Centered>
          <S.Loader size="big">Loading failed uploads</S.Loader>
        </S.Centered>
      )}

      {uploadsFailed.length === 0 && !loading && (
        <S.Centered>
          <S.Text>No failed uploads to display.</S.Text>
        </S.Centered>
      )}

      {uploadsFailed.length > 0 && (
        <UploadsTable data={uploadsFailed} />
      )}
    </S.Container>
  );
};

export default withDashboardSidebar(Uploads);
